(function () {
  "use strict";

  var SELECTOR = 'img[src*="maksuturva.fi/public_img/paymentmethods/"]';

  function setDimensions(img) {
    if (!img || img.nodeType !== 1) return;

    var hasWidth = img.hasAttribute("width");
    var hasHeight = img.hasAttribute("height");
    if (hasWidth && hasHeight) return;

    var apply = function () {
      var width = img.naturalWidth || img.width || img.clientWidth;
      var height = img.naturalHeight || img.height || img.clientHeight;
      if (!width || !height) return;
      if (!hasWidth && !img.hasAttribute("width")) {
        img.setAttribute("width", String(width));
      }
      if (!hasHeight && !img.hasAttribute("height")) {
        img.setAttribute("height", String(height));
      }
    };

    apply();
    if (img.hasAttribute("width") && img.hasAttribute("height")) return;

    if (img.complete) {
      apply();
      return;
    }

    img.addEventListener("load", apply, { once: true });
  }

  function scan(root) {
    if (!root) return;

    if (root.matches && root.matches(SELECTOR)) {
      setDimensions(root);
    }

    if (!root.querySelectorAll) return;
    var images = root.querySelectorAll(SELECTOR);
    for (var i = 0; i < images.length; i += 1) {
      setDimensions(images[i]);
    }
  }

  function observe() {
    if (!window.MutationObserver) return;

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        var mutation = mutations[i];
        if (mutation.type === "attributes") {
          if (mutation.target && mutation.target.matches && mutation.target.matches(SELECTOR)) {
            setDimensions(mutation.target);
          }
          continue;
        }

        for (var j = 0; j < mutation.addedNodes.length; j += 1) {
          var node = mutation.addedNodes[j];
          if (node && node.nodeType === 1) {
            scan(node);
          }
        }
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["src"]
    });
  }

  function init() {
    scan(document);
    observe();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
